import { loadable } from 'utils';

export const Contact = loadable(() => import('./Contact'), {});
